import { useEffect, useState } from "react";
import {
  Paper,
  Modal,
  MenuList,
  MenuItem,
  ClickAwayListener,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { ReactComponent as CLoseMark } from "../../resources/icon/close.svg";

import "./ErrorNote.css";
import { t } from "i18next";

import { ReactComponent as Issues } from "../../resources/icon/issues.svg";

export type ErrorItem = {
  code?: string;
  message: string;
};

export type ErrorNoteProps = {
  error?: Array<ErrorItem>;
  clearError: Function;
  isYellow?: boolean;
};

const ErrorNote = (props: ErrorNoteProps) => {
  const { t } = useTranslation();

  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (props.error && props.error.length > 0) {
      setMenuOpen(true);
    } else {
      setMenuOpen(false);
    }
  }, [props.error]);

  return (
    <Modal
      open={menuOpen}
      onClose={() => {
        props.clearError();
      }}
      className="Error-note-box"
    >
      <div className="Error-note-box-Inner">
        <div className="Error-note-Buttons">
          <CLoseMark
            onClick={() => {
              props.clearError();
            }}
            className="CloseIcon"
          />
        </div>

        <div
          className={
            props.isYellow ? "Error-note-TopBar Yellow" : "Error-note-TopBar"
          }
        >
          <div className="Error-note-Title">{t("error:errorTitle")}</div>
        </div>

        <div className="Error-note-List">
          <div className="Left-side">
            <Issues
              className={
                props.isYellow ? "Issues-Icon Yellow-Icon" : "Issues-Icon"
              }
            />
          </div>
          <div className="Right-side">
            {props.error &&
              props.error.length > 0 &&
              props.error.map((item: ErrorItem, index: any) => {
                const message = item.code
                  ? item.message + " (" + item.code + ") "
                  : item.message;
                return (
                  <div
                    className="Error-note-line-Box"
                    key={"error-line-" + index}
                  >
                    {message}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorNote;
